export default __webpack_public_path__ + "static/media/blend-concerns.620b894a.svg";